'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactImageSlider = require('react-image-slider');

var _reactImageSlider2 = _interopRequireDefault(_reactImageSlider);

var _lib = require('helpers/lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop,
    media: state.shops.media
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(GalleryDetail, _Component);

  function GalleryDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GalleryDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GalleryDetail.__proto__ || (0, _getPrototypeOf2.default)(GalleryDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModalMedia: false,
      showAllMedia: false,
      currentIndexImage: 0,
      style: _this.props.style || require('./Detail.scss')
    }, _this.handleShowModalMedia = function (indexImage) {
      _this.setState({ showModalMedia: true, currentIndexImage: indexImage });
    }, _this.handleShowAllMedia = function () {
      _this.setState({
        showAllMedia: true
      });
    }, _this.setNewCurrentIndex = function (index) {
      _this.setState({
        currentIndexImage: index
      });
    }, _this.nextImage = function () {
      var index = _this.state.currentIndexImage + 1;
      var lenMedia = _this.props.media && _this.props.media.length || 0;
      if (index >= lenMedia) {
        index = 0;
      }
      _this.setState({
        currentIndexImage: index
      });
    }, _this.handleCloseModalMedia = function () {
      _this.setState({ showModalMedia: false });
    }, _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
      event.target.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GalleryDetail, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = this.state.style;
      var _props = this.props,
          media = _props.media,
          shop = _props.shop;
      var _state = this.state,
          showAllMedia = _state.showAllMedia,
          currentIndexImage = _state.currentIndexImage,
          showModalMedia = _state.showModalMedia;

      var firstMedia = '';
      var restMedia = [];
      var mediaMore = [];
      if (media.length > 0) {
        firstMedia = media[0];
      }
      if (media.length > 7) {
        mediaMore = media.slice(0);
        mediaMore = mediaMore.splice(7, media.length - 1);
        restMedia = media.slice(0);
        restMedia = restMedia.splice(1, 6);
      } else if (media.length > 1) {
        restMedia = media.slice(0);
        restMedia = restMedia.splice(1, media.length - 1);
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.contentTab + ' ' + styles.gallery,
          id: 'gallery',
          ref: 'gallery'
        },
        _react2.default.createElement(
          'div',
          { className: styles.headerTab },
          _react2.default.createElement(
            'h2',
            { className: styles.leftHeaderTab },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'picture' }),
            'H\xECnh \u1EA3nh',
            ' ',
            _react2.default.createElement(
              'span',
              { className: styles.span },
              media.length,
              ' \u1EA3nh, 0 video'
            )
          ),
          media.length > 7 && !showAllMedia && _react2.default.createElement(
            'div',
            {
              className: styles.rightHeaderTab,
              onClick: function onClick() {
                return _this2.handleShowAllMedia();
              }
            },
            'Xem th\xEAm',
            _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
              className: styles.arrowRight,
              glyph: 'menu-right'
            }, 'className', styles.arrowRight))
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyTab },
          media.length > 0 && _react2.default.createElement(
            'div',
            { style: { width: '100%', float: 'left' } },
            _react2.default.createElement(
              'div',
              { className: styles.leftBodyTab },
              _react2.default.createElement(
                'div',
                { className: styles.bigImage },
                _react2.default.createElement('img', {
                  src: (0, _lib.getUrlImage)(firstMedia.asset),
                  alt: (shop ? shop.name : 'detail') + ' 0 gallaries',
                  onClick: function onClick() {
                    return _this2.handleShowModalMedia(0);
                  },
                  onError: this.onErrorImage
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.rightBodyTab },
              restMedia.map(function (asset, idx) {
                return _react2.default.createElement(
                  'div',
                  { className: styles.smallImage, key: idx },
                  _react2.default.createElement('img', {
                    src: (0, _lib.getUrlImage)(asset.asset),
                    alt: (shop ? shop.name : 'detail') + ' ' + idx + ' gallaries',
                    onClick: function onClick() {
                      return _this2.handleShowModalMedia(idx + 1);
                    },
                    onError: _this2.onErrorImage
                  })
                );
              })
            ),
            showAllMedia && mediaMore.length > 0 && _react2.default.createElement(
              'div',
              { className: styles.moreMedia },
              mediaMore.map(function (med, idx) {
                return _react2.default.createElement(
                  'div',
                  { className: styles.smallImage, key: 'more' + idx },
                  _react2.default.createElement('img', {
                    src: (0, _lib.getUrlImage)(med.asset),
                    alt: (shop && shop.name) + ' ' + idx + ' gallaries',
                    onClick: function onClick() {
                      return _this2.handleShowModalMedia(idx + 7);
                    },
                    onError: _this2.onErrorImage
                  })
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            onHide: this.handleCloseModalMedia,
            show: showModalMedia,
            hide: this.handleCloseModalMedia,
            className: styles.modalMedium
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.headerModalImage },
                shop && _react2.default.createElement(
                  'div',
                  null,
                  shop.name,
                  ' ',
                  _react2.default.createElement(
                    'span',
                    { className: styles.span },
                    media.length,
                    ' \u1EA3nh, 0 video'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'div',
              { className: styles.modalImage },
              media && _react2.default.createElement(
                'div',
                {
                  className: styles.bgImageDefault,
                  onClick: function onClick() {
                    return _this2.nextImage();
                  }
                },
                media.length > 0 && _react2.default.createElement(
                  'div',
                  {
                    className: styles.currentImage,
                    style: {
                      backgroundImage: 'url("' + (0, _lib.getUrlImage)(media[currentIndexImage].asset) + '")'
                    }
                  },
                  _react2.default.createElement('div', { className: styles.fadeInfoImage }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.authorImage },
                    _react2.default.createElement('img', {
                      src: (0, _lib.getAvatar)(media[currentIndexImage].author),
                      alt: 'user avatar',
                      style: {
                        float: 'left',
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        display: 'inline-block',
                        marginRight: '9px',
                        objectFit: 'cover'
                      }
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.authorImageName },
                      media[currentIndexImage].author && media[currentIndexImage].author.profile && media[currentIndexImage].author.profile.name || 'Cửa hàng'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.dateUpload },
                      ' ',
                      '(',
                      (0, _lib.renderTime)(media[currentIndexImage].date),
                      ')'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.imageIndex },
                      currentIndexImage + 1,
                      '/',
                      media.length
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactImageSlider2.default,
                { visibleItems: 5, isInfinite: false },
                media.map(function (image, key) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: key,
                      onClick: function onClick() {
                        return _this2.setNewCurrentIndex(key);
                      },
                      style: { cursor: 'pointer' }
                    },
                    _react2.default.createElement('img', {
                      src: (0, _lib.getUrlImage)(image.asset),
                      alt: (shop && shop.name) + ' ' + key + ' gallaries',
                      style: { objectFit: 'contain' },
                      className: currentIndexImage === key ? 'active' : '',
                      onError: _this2.onErrorImage
                    }),
                    _react2.default.createElement(
                      'div',
                      { style: { marginTop: '7px' } },
                      _react2.default.createElement('img', {
                        src: (0, _lib.getAvatar)(image.author),
                        alt: 'user avatar',
                        style: {
                          width: '34px',
                          height: '34px',
                          borderRadius: '50%',
                          float: 'left',
                          marginRight: '9px',
                          userSelect: 'none',
                          objectFit: 'cover'
                        },
                        onError: _this2.onErrorImage
                      }),
                      _react2.default.createElement(
                        'div',
                        {
                          style: {
                            float: 'left',
                            width: 'calc(100% - 45px)',
                            fontWeight: 'bold',
                            fontSize: '12px'
                          }
                        },
                        image.author && image.author.profile && image.author.profile.name || 'Cửa hàng'
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return GalleryDetail;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object,
  media: _react.PropTypes.array,
  style: _react.PropTypes.any
}, _temp2)) || _class);
exports.default = GalleryDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/GalleryDetail.js
// module id = 723
// module chunks = 0